/*
* Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
  distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
  prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
  content, please contact the author for proper authorization and agreement.
  */
import React, { useCallback } from 'react'
import clsx from 'clsx'

export type UiInitialsAvatarSize = 'sm' | 'md' | 'lg' | 'xl'

interface UiInitialsAvatarProps {
    firstName?: string
    lastName?: string
    size?: UiInitialsAvatarSize
    className?: string
}

const sizeClasses: Record<UiInitialsAvatarSize, string> = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-12 h-12 text-base',
    lg: 'w-16 h-16 text-xl',
    xl: 'w-24 h-24 text-3xl',
}

const UiInitialsAvatar: React.FC<UiInitialsAvatarProps> = ({
    firstName,
    lastName,
    size = 'md',
    className,
}) => {
    const getMonogram = useCallback(() => {
        const first = firstName?.trim().charAt(0).toUpperCase() || ''
        const last = lastName?.trim().charAt(0).toUpperCase() || ''
        return first + last || '??'
    }, [firstName, lastName])

    return (
        <div
            className={clsx(
                'UiInitialsAvatar',
                'bg-cta-light text-white rounded-full flex items-center justify-center font-bold shadow-lg ring-4 ring-cta-light/10',
                sizeClasses[size],
                className
            )}
        >
            {getMonogram()}
        </div>
    )
}

export default UiInitialsAvatar
